<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      width="1000px"
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_PushResultLog')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'450px'}"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { queryApiReqLog } from '@/api/booking/job'
import CustomLabelUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'PushLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_Sender'), field: 'CREATED_BY', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Message.Receivable') + '/' + this.$t('Message.Payable'), field: 'receivable', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('Message.Receivable') : this.$t('Message.Payable')
          } },
        { headerName: this.$t('FinanceManage.adChargeInfo_settleAccountsTo'), field: 'accountId', width: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendDate'), field: 'DATE_CREATED', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ResultSuccess'), field: 'STATE', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('Message.Failure') : this.$t('Message.Success')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ResultMessage'), field: 'errorMsg', width: 300,
          tooltipValueGetter: (params) => params.value
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.jobUuid) {
        this.$message.warning(this.$('SeaExport.CheckBusinessUuid'))
        return
      }
      this.loading = getLoading()
      queryApiReqLog(this.jobUuid).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

